const doc = [({"en":({"js":({"admin":({"bundles":({"select":({"choose_bundle":"Choose bundle"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;